import React from "react";
import { Box, Flex, Text } from "@chakra-ui/layout";
import { Avatar, AvatarProps } from "@chakra-ui/react";
import { useMemo } from "react";

export interface CardPersonProps {
  avatarUrl?: string;
  nome?: string;
  subtitle?: string;
  date?: string;
  border?: string;
  backgroundColor?: string;
  avatarProps?: AvatarProps;
  isPeriod?: boolean;
  dateStart?: string;
  dateEnd?: string;
  childrenSubtitle?: any;
  alingAvatar?: string;
  fontSizeName?: string;
  fontSizeSubtitle?: string;
}

function CardPerson({
  avatarUrl,
  nome,
  subtitle,
  date,
  backgroundColor,
  border,
  avatarProps,
  isPeriod = false,
  dateStart,
  dateEnd,
  childrenSubtitle,
  alingAvatar,
  fontSizeName = "16px",
  fontSizeSubtitle = "14px",
}: CardPersonProps) {
  const MemoAvatar = useMemo(() => {
    return (
      <Avatar
        key={avatarUrl?.trim()}
        name={nome?.trim()}
        src={avatarUrl?.trim()}
        bg={backgroundColor}
        {...avatarProps}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatarUrl, nome, backgroundColor]);

  return (
    <Flex flex={1} flexDirection="row" align={alingAvatar}>
      <Flex borderRadius={34} border={border} p="2px">
        {MemoAvatar}
      </Flex>
      <Flex
        pt="4px"
        px="12px"
        flex={1}
        justifyContent="center"
        flexDir="column"
      >
        <Box>
          <Box
            color="gray.800"
            fontWeight="600"
            fontSize={fontSizeName}
            pb="2"
            lineHeight="16px"
          >
            {nome?.trim()}
          </Box>
          <Flex
            justifyContent="space-between"
            fontWeight="300"
            fontSize={fontSizeSubtitle}
            lineHeight="14px"
          >
            {subtitle}
            {childrenSubtitle}
          </Flex>
        </Box>
      </Flex>
      <Flex
        pt="4px"
        h="48px"
        alignItems="flex-end"
        justifyContent="center"
        flexDir="column"
      >
        {date ? (
          <Text fontWeight="400" fontSize="12px">
            {date}
          </Text>
        ) : null}
        {isPeriod && dateStart && dateEnd && dateEnd !== dateStart ? (
          <Text fontWeight="500" fontSize="12px">
            Período: {dateStart} á {dateEnd}
          </Text>
        ) : null}
      </Flex>
    </Flex>
  );
}

export default CardPerson;
